import { OptimizationStatus } from '@/shared/generated'

const STATUS_ORDER = [
	OptimizationStatus.Locked,
	OptimizationStatus.Finished,
	OptimizationStatus.Failed,
	OptimizationStatus.UpdatingFailed,
	OptimizationStatus.Pending,
	OptimizationStatus.New,
	OptimizationStatus.Scheduled,
] as const

const getStatusOrder = (status?: OptimizationStatus): number => {
	const index = STATUS_ORDER.indexOf(status as (typeof STATUS_ORDER)[number])

	return index === -1 ? STATUS_ORDER.length : index + 1
}
/**
 * Sort optimization groups by status
 * @param data - The data to sort
 * @returns The sorted data
 */
export const sortOptimizationGroupsByStatus = (
	data:
		| {
				id: string
				name: string
				status: OptimizationStatus | undefined
		  }[]
		| []
) =>
	data
		? [...data].sort(
				(a, b) => getStatusOrder(a.status) - getStatusOrder(b.status)
			)
		: []
